import { FormattedMessage } from 'react-intl';
import { localizationFallbackItems } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var LocalizedText = function LocalizedText(_ref) {
  var localizationItem = _ref.localizationItem,
    values = _ref.values;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    id: localizationItem,
    defaultMessage: localizationFallbackItems[localizationItem],
    values: values
  });
};